import axios from 'axios';
export const getFaq = () => {
    return axios.get(`belajar-id/cms/v1/cms-client/faq`);
};
export const getFaqCategory = (params = {}) => {
    return axios.get(`belajar-id/cms/v1/cms-client/faq_category`, {
        params,
    });
};
